
    <div class="row g-3">
        <div class="col-4">
            <div class="card">
                <div class="card-body">
                    <label class="form-label" i18n>Campaign</label>
                    <select *ngIf="adsCampaigns.length > 0" class="form-select">
                        <option [ngValue]="null" i18n>All</option>
                        <option *ngFor="let adsCampaign of adsCampaigns" [ngValue]="adsCampaign.id">{{ adsCampaign.name }}</option>
                    </select>
                    <a *ngIf="adsCampaigns.length == 0" routerLink="campaigns/create" class="btn btn-primary w-100">Create first campaign</a>
                </div>
            </div>
        </div>
        <div class="col-8">
            <div class="card">
                <div class="card-body" *ngIf="loaded && (!adsOrganization.company_id || !adsOrganization.street_address || !adsOrganization.postal_code || !adsOrganization.city || !adsOrganization.country)">
                    <h4 i18n>Information missing</h4>
                    <p i18n>The following information is missing and needs to be completed before you can start running ad campaings:</p>
                    <ul>
                        <li *ngIf="loaded && !adsOrganization.company_id" i18n>Business ID</li>
                        <li *ngIf="loaded && !adsOrganization.street_address" i18n>Street address</li>
                        <li *ngIf="loaded && !adsOrganization.postal_code" i18n>Postal code</li>
                        <li *ngIf="loaded && !adsOrganization.city" i18n>City</li>
                        <li *ngIf="loaded && !adsOrganization.country" i18n>Country</li>
                    </ul>
                    <a routerLink="/settings/organization" class="btn btn-primary" i18n>Complete information</a>
                </div>
            </div>
        </div>
    </div>
